import { MutationTree } from "vuex";
import { PartnerUserRolesState } from "@/store/user_management/partner_user_roles/types";

export const mutations: MutationTree<PartnerUserRolesState> = {
  setPartnerUserRoles: (state, payload) => {
    state.partnerUserRoles = payload;
  },
  setPartnerUserRolesItem: (state, payload) => {
    state.partnerUserRolesItem = payload;
  },
  setPageBlocks: (state, payload) => {
    state.pageBlocks = payload;
  },
};
